var map = {
	"./de.png": "+aMT",
	"./en.png": "doxS",
	"./es.png": "HWyR",
	"./fr.png": "3s7B",
	"./ja.png": "O+sr",
	"./ko.png": "NOh7",
	"./pt.png": "0pwv",
	"./ru.png": "0kL7",
	"./th.png": "FZHJ",
	"./zh-Hant.png": "Mnvh"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "l7ql";